import axiosInstance from '../helpers/axios';

/**
 * POST /api/ops/programs/:id/send — the Team Pass welcome (Bcc every
 * enabled member, Cc the POC, from and to cx@) and the CSM handoff to the
 * POC. One outbox row each; held in dry-run like every other send.
 */
export type TProgramSendKind = 'welcome' | 'handoff';

export type TProgramSendResult = {
  kind: TProgramSendKind;
  templateName: string;
  to: string;
  cc?: string[];
  bccCount?: number;
  membersWithoutEmail?: number;
  pocMissing?: boolean;
  outboxId: string;
  status: string;
  holdReason?: string | null;
  link: string | null;
  warning: string | null;
};

export const sendFromProgram = async (
  programId: string,
  body: { kind: TProgramSendKind; to?: string },
) =>
  (
    await axiosInstance.post<TProgramSendResult>(
      `ops/programs/${encodeURIComponent(programId)}/send`,
      body,
    )
  ).data;
